<template>
    <div class="mainpage">
        <div ref="leftpage" class="leftpage" v-show="isLeftPageVisible">
            <ul class="ulstyle">
                <li
                    v-for="(item,index) in navItems"
                    :key="`${item.path}-${index}`"
                    :class="{ selected: isSelected(item) }"
                    @click="navigateToDocument(item)"
                >
                    {{ item.label }}
                </li>
            </ul>
        </div>


        <div class="rightpage">
            <div class = "showindex">
                <button id="showleftpage" @click="toggleLeftPage">
                    <img src="../image/index.png" alt="Toggle Left Page" width="25" height="25" />
                </button>
                <router-view></router-view>
            </div>
            
        </div>
    </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getEnglishNavItems } from "../shared/siteNavigation";
import { useSiteLanguage } from "../store/siteLanguage";

const router = useRouter();
const route = useRoute();
const { lang } = useSiteLanguage();
const isLeftPageVisible = ref(window.innerWidth >= 768);
const navItems = computed(() => getEnglishNavItems(lang.value));

function toggleLeftPage() {
    isLeftPageVisible.value = !isLeftPageVisible.value;
}

function handleResize() {
    isLeftPageVisible.value = window.innerWidth >= 768;
}

function navigateToDocument(item) {
    router.push(item.path);
}

function isSelected(item) {
    return route.fullPath === item.path;
}

onMounted(() => {
    window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", handleResize);
});
</script>

<style lang="scss">
    @import './Maincss.scss';
</style>
